import { combineReducers } from 'redux';

import ids from './ids';
import activeRequests from './active-requests';

export default combineReducers({
  ids,
  activeRequests,
});



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/channel-videos/index.js